import React from "react";
import { DEFAULT_PROFILE_IMAGE } from "../../../app/utils/common/baseUrl";

const DashboardWidgetProfilePhoto = ({ profileImage, name }) => (
  <img
    className="dashboard-widget-photo"
    src={profileImage || DEFAULT_PROFILE_IMAGE}
    alt={name ? `${name} profile` : "Profile"}
    onError={(e) => {
      e.currentTarget.onerror = null;
      e.currentTarget.src = DEFAULT_PROFILE_IMAGE;
    }}
  />
);

export default DashboardWidgetProfilePhoto;
